import { SystemVariables } from "src/app/common/services/external-settings/external-settings.interface";
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SystemContactUtilityService {

  public static getInstitutionName(sysVar: SystemVariables): string {
    return sysVar.institutionName;
  }

  public static getContactAddress1(sysVar: SystemVariables): string {
    return sysVar.contactAddress1 || "";
  }

  public static getContactAddress2(sysVar: SystemVariables): string {
    return sysVar.contactAddress2 || "";
  }

  public static getCity(sysVar: SystemVariables): string {
    return sysVar.city || "";
  }

  public static getStateOrProvince(sysVar: SystemVariables): string {
    return sysVar.stateOrProvince || '';
  }

  public static getZipOrPostal(sysVar: SystemVariables): string {
    return sysVar.zipOrPostal || '';
  }

  public static getCountry(sysVar: SystemVariables): string {
    return sysVar.country || '';
  }

  public static getContactPhone1(sysVar: SystemVariables): string {
    return sysVar.contactPhone1 || '';
  }

  public static getContactFax(sysVar: SystemVariables): string {
    return sysVar.contactFax || '';
  }

  public static getContactEmail(sysVar: SystemVariables): string {
    return sysVar.contactEmail || '';
  }

  public static getCopyRightMessage(sysVar: SystemVariables): string {
    return sysVar.copyrightMessage || '';
  }

  public static hasInstitutionName(sysVar: SystemVariables): boolean {
    return (sysVar.institutionName !== null && sysVar.institutionName.length > 0);
  }

  public static hasContactAddress1(sysVar: SystemVariables): boolean {
    return (sysVar.contactAddress1 !== null && sysVar.contactAddress1.length > 0);
  }

  public static hasContactAddress2(sysVar: SystemVariables): boolean {
    return (sysVar.contactAddress2 !== null && sysVar.contactAddress2.length > 0);
  }

  public static hasAddress(sysVar: SystemVariables): boolean {
    return SystemContactUtilityService.hasContactAddress1(sysVar) || SystemContactUtilityService.hasContactAddress2(sysVar);
  }

  public static hasCity(sysVar: SystemVariables): boolean {
    return (sysVar.city !== null && sysVar.city.length > 0);
  }

  public static hasStateOrProvince(sysVar: SystemVariables): boolean {
    return (sysVar.stateOrProvince !== null && sysVar.stateOrProvince.length > 0);
  }

  public static hasZipOrPostal(sysVar: SystemVariables): boolean {
    return (sysVar.zipOrPostal !== null && sysVar.zipOrPostal.length > 0);
  }

  public static hasCityLine(sysVar: SystemVariables): boolean {
    return SystemContactUtilityService.hasCity(sysVar) || 
          SystemContactUtilityService.hasStateOrProvince(sysVar) || 
          SystemContactUtilityService.hasZipOrPostal(sysVar);
  }

  public static hasCountry(sysVar: SystemVariables): boolean {
    return (sysVar.country !== null && sysVar.country.length > 0);
  }

  public static hasContactPhone1(sysVar: SystemVariables): boolean {
    return (sysVar.contactPhone1 !== null && sysVar.contactPhone1.length > 0);
  }

  public static hasContactEmail(sysVar: SystemVariables): boolean {
    return (sysVar.contactEmail !== null && sysVar.contactEmail.length > 0);
  }

  public static getAddress(sysVar: SystemVariables): string {
    let address = '';
    if (SystemContactUtilityService.hasContactAddress1(sysVar)){
      address = sysVar.contactAddress1!;
    }
    if (SystemContactUtilityService.hasContactAddress1(sysVar)) {
      address = address + ', ' + sysVar.contactAddress2;
    }
    return address;
  }

  public static getCityLine(sysVar: SystemVariables): string {
    let cityLine = '';
    if (SystemContactUtilityService.hasCity(sysVar)) {
      cityLine = sysVar.city!;
      if (SystemContactUtilityService.hasStateOrProvince(sysVar)) {
        cityLine = cityLine + ', ' + sysVar.stateOrProvince;
      }
      if (SystemContactUtilityService.hasZipOrPostal(sysVar)) {
        cityLine = cityLine + ' ' + sysVar.zipOrPostal;
      }
    }
    return cityLine;
  }
}